import Intercom from '@intercom/messenger-js-sdk';

const init = () => {
  const config = JSON.parse(document.getElementById('intercom-config')?.textContent || '{}');

  if (!config)
    return;

  Intercom({
    app_id: config.app_id,
    ...(config.user && { 
      user_id: config.user.id_,
      email: config.user.email
    })
  });
};

export { init };
